<div class="restrict-page">
  <div class="restricted-content">
    <picture>
      <img
        [ngSrc]="pageData.imageUrl"
        [alt]="pageData.alternativeText"
        height="136"
        width="184" />
    </picture>
    <h2>{{ pageData.title }}</h2>
    <div [innerHTML]="pageData.description"></div>
  </div>
</div>
